// extracted by mini-css-extract-plugin
export default {"h1Descriptor":"h1Descriptor--ESNzo","pageHeading":"pageHeading--ESNzo"};